import { endpoint } from '@/services/api/endpoint';
import { CompanyPathSchema } from '@/services/api/schemas';
import { CompanyCapabilitiesSchema, CompanyFeatureValuesBodySchema } from '@/domain/companies/schemas';

export const companiesApi = {
  getCapabilities: endpoint({
    method: 'GET',
    url: (p: { companyId: string }) => `preferences/company/${p.companyId}/feature_set`,
    path: CompanyPathSchema,
    response: CompanyCapabilitiesSchema,
  }),
  setFeatures: endpoint({
    method: 'POST',
    url: (p: { companyId: string }) => `preferences/company/${p.companyId}/feature_set`,
    path: CompanyPathSchema,
    body: CompanyFeatureValuesBodySchema,
    response: CompanyCapabilitiesSchema,
  }),
};
